// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cal-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.cal-toolbar-navigate {
  display: flex;
  align-items: center;
}

.cal-toolbar-today {
  display: flex;
  align-items: center;
  padding: 7px 12px;
  margin-inline-end: 24px;
}

.cal-toolbar-select,
.cal-toolbar-today {
  height: 36px;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-transform: "capitalize";
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-text);
  letter-spacing: 0.25px;
  background-color: var(--color-surface);
}
.cal-toolbar-select:hover,
.cal-toolbar-today:hover {
  cursor: pointer;
  background-color: var(--color-surface-muted);
  color: var(--color-text);
}
`, "",{"version":3,"sources":["webpack://./src/common/views/calendar/custom-toolbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;;EAEE,eAAe;EACf,4CAA4C;EAC5C,wBAAwB;AAC1B","sourcesContent":[".cal-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.cal-toolbar-navigate {\n  display: flex;\n  align-items: center;\n}\n\n.cal-toolbar-today {\n  display: flex;\n  align-items: center;\n  padding: 7px 12px;\n  margin-inline-end: 24px;\n}\n\n.cal-toolbar-select,\n.cal-toolbar-today {\n  height: 36px;\n  font-size: 14px;\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  text-transform: \"capitalize\";\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  color: var(--color-text);\n  letter-spacing: 0.25px;\n  background-color: var(--color-surface);\n}\n.cal-toolbar-select:hover,\n.cal-toolbar-today:hover {\n  cursor: pointer;\n  background-color: var(--color-surface-muted);\n  color: var(--color-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
